import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Vacation } from 'src/app/shared/models/vacation';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class VacationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	addVacationForEmployee(
		vacation: Vacation[],
		employeeId: number
	): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.employeeUrl}/${employeeId}/vacation`,
			`addVacationForEmployee`,
			vacation
		);
	}

	updateVacationForEmployee(
		vacation: Vacation,
		employeeId: number
	): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.employeeUrl}/${employeeId}/vacation`,
			`updateVacationForEmployee`,
			vacation
		);
	}

	deleteVacation(vacationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.vacationUrl}/${vacationId}`,
			`deleteVacation`
		);
	}
}
